import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ShortcutsUtils } from './shortcuts.constants';

interface ShortcutCategory {
  name: string;
  shortcuts: { name: string; shortcut: string }[];
}

@Injectable({
  providedIn: 'root',
})
export class ShortcutsService {
  private showShortcutsOverlaySubject = new BehaviorSubject<boolean>(false);
  showShortcutsOverlay$ = this.showShortcutsOverlaySubject.asObservable();

  getShortcutCategories(): ShortcutCategory[] {
    return ShortcutsUtils.getShortcutCategories();
  }

  showShortcuts() {
    this.showShortcutsOverlaySubject.next(true);
  }

  hideShortcuts() {
    this.showShortcutsOverlaySubject.next(false);
  }
}
